/* eslint-disable */
export default {
  add: 'Toevoegen',
  noCalls: 'Geen beschikbare oproepen',
  activeCall: 'Actieve oproep',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
